<template lang="html">
    <div class="table-responsive">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th v-for="(header, index) in headers" :style="header.style" v-on:click="sort(index)">
                        <div class="title">
                            {{ header.title }}
                            <div class="pull-right">
                                <span class="fa" v-if="header.sortBy != ''" :class="{'fa-sort-amount-asc': header.sortBy == 'asc', 'fa-sort-amount-desc': header.sortBy == 'desc'}"></span>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows">
                    <td v-for="cell in row" :style="cell < 1 ? 'color: #999': ''">
                        {{ cell }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import keys from 'lodash.keys';
import forEach from 'lodash.foreach';
import sortBy from 'lodash.sortby';
import map from 'lodash.map';
import moment from 'moment';

export default {
    props: ['value'],
    data: function () {
        return {
            headers: [],
            rows: []
        }
    },
    watch: {
        value: function () {
            var $this = this;
            var formatter = new Intl.NumberFormat('tr-TR', {
                style: 'decimal',
                currency: 'TRY',
                minimumFractionDigits: 0
            });
            this.headers = [{title: 'Tarih', style: 'width: 120px;', sortBy: 'asc'}];
            this.rows = [];
            forEach(keys(this.value), function (date, index) {
                var row = [date];
                var totalValue = '';
                forEach($this.value[date], function (value, category) {
                    if (index == 0 && category != '__total') {
                        $this.headers.push({title: category, sortBy: ''});
                    }
                    value = formatter.format(value);
                    if (category == '__total') {
                        totalValue = value;
                    } else {
                        row.push(value);
                    }
                });
                row.push(totalValue);
                $this.rows.push(row);
            });
            this.headers.push({title: 'Toplam', sortBy: ''});
            this.sort(0);
        }
    },
    methods: {
        sort: function (index) {
            var sortedData = map(sortBy(this.rows, function (a) {
                if (index == 0) {
                    return moment(a[index], 'DD.MM.YYYY');
                } else {
                    return parseFloat(a[index].replace('.', ''));
                }
            }));
            if (this.headers[index].sortBy == 'desc') {
                this.headers[index].sortBy = 'asc';
                this.rows = sortedData;
            } else {
                this.headers[index].sortBy = 'desc';
                this.rows = sortedData.reverse();
            }
            forEach(this.headers, function (header, headerIndex) {
                if (index != headerIndex) {
                    header.sortBy = '';
                }
            });
        }
    }
}
</script>

<style lang="css" scoped>
    th {
        cursor: pointer;
        background: #eee;
        border-bottom: 2px solid #eceeef;
        vertical-align: bottom;
    }

    .title {
        position: relative;
        padding: 4px 18px 4px 4px;
        display: block;
    }

    .title:after, .title:before {
        box-sizing: inherit;
    }
</style>



// WEBPACK FOOTER //
// table.vue?6adfb0ee